const LegalModule = {
    namespaced: true,
    state: {
        refreshKey: null,
        clientTypes: []
    },
    actions: {
        REFRESH({ state, commit }, refreshKey) {
            commit('SetRefreshLegalList', refreshKey);
        },
        SET_CLIENT_TYPES({ state, commit }, clientTypes) {

            commit('SetClientTypes', clientTypes);
        },
    },
    mutations: {
        SetRefreshLegalList: function (state, refreshKey) {
            state.refreshKey = refreshKey;
        },
        SetClientTypes: function (state, clientTypes) {
            state.clientTypes = clientTypes.data
        }
    },
    getters: {
        GetRefreshLegalList: function (state) {
            try {
                return state.refreshKey;
            } catch (err) {
                return null;
            }
        },
        GetClientTypes: function (state) {
            return state.clientTypes
        },
        ClientTypesLoaded: function (state) {

            return state.clientTypes.length != 0
        }
    },
};
export default LegalModule;